const animation = {
  transitionDefault: "all 300ms ease-out",
  transitionEaseInOut: "all 0.3s ease-in-out"
};

export default animation;
